import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import Vue from 'vue';
import { imageCropModalService } from "@/components/kiva/kv-image-crop/KvImageCropModalService";
Vue.mixin({
  data: function data() {
    var _this = this;
    return {
      datePickerLang: {
        formatLocale: {
          firstDayOfWeek: 1
        },
        monthBeforeYear: false
      },
      confingRedactorX: {
        // plugins: [
        //   'clips',
        //   'fontsize',
        //   'fullscreen',
        //   'table',
        //   'inlinestyle'
        // ],
        // buttonsHide: ['html', 'align', 'strikethrough'],
        // buttons: ['redo', 'undo', 'format', 'bold', 'italic', 'lists', 'image', 'file', 'link', 'clips'],
        // editor: { focus: false, height: '200px' }
        source: false,
        reorder: true,
        control: true,
        context: true,
        minHeight: '500px',
        // toolbar: true,
        editor: {
          focus: true,
          notranslate: true
        },
        classes: {
          'p': 'kv-editor-p',
          'heading ': 'kv-heading',
          'image': 'kv-editor-img',
          'table': 'kv-editor-table'
        },
        clips: {
          items: {
            "kiva-panel-ul": {
              title: 'Kiva Panel ul.',
              html: '<p  class="kiva-panel-title">Title</p><ul  class="kiva-panel-ul"><li>Item</li></ul>'
            },
            "kiva-title-panel": {
              title: 'Kiva Panel',
              html: '<p  class="kiva-panel-title">Title</p><p  class="kiva-panel-content">Content</p>'
            },
            "kiva-pre": {
              title: 'Kiva Code',
              html: '<p  class="kiva-panel-title">Title</p><pre  class="kiva-panel-content"></pre>'
            },
            "kiva-title": {
              title: 'Kiva Title',
              html: '<p  class="kiva-panel-title">Title</p> '
            },
            "kiva-panel": {
              title: 'Kiva Panel',
              html: '<p  class="kiva-panel-content">Content</p>'
            },
            "kiva-article": {
              title: 'Kiva Panel w Title',
              html: '<p  class="kiva-panel-title">Title</p><table  class="kiva-panel-table"><tr><td>Content</td></tr></table>'
            }
          }
        },
        addbar: {
          add: {
            "warningbox": {
              title: 'Warning',
              position: {
                after: 'text'
              },
              icon: '<svg class="fal fa-exclamation-circle"></svg>',
              template: '<p class="kv-editor-infobox warning"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path d="M8.49219 0C9.17969 0 9.84115 0.0911458 10.4766 0.273437C11.1172 0.450521 11.7161 0.703125 12.2734 1.03125C12.8307 1.35417 13.3359 1.74479 13.7891 2.20312C14.2474 2.65625 14.638 3.16146 14.9609 3.71875C15.2891 4.27604 15.5417 4.875 15.7188 5.51562C15.901 6.15104 15.9922 6.8125 15.9922 7.5C15.9922 8.1875 15.901 8.85156 15.7188 9.49219C15.5417 10.1276 15.2891 10.724 14.9609 11.2812C14.638 11.8385 14.2474 12.3464 13.7891 12.8047C13.3359 13.2578 12.8307 13.6484 12.2734 13.9766C11.7161 14.2995 11.1172 14.5521 10.4766 14.7344C9.84115 14.9115 9.17969 15 8.49219 15C7.80469 15 7.14063 14.9115 6.5 14.7344C5.86458 14.5521 5.26823 14.2995 4.71094 13.9766C4.15365 13.6484 3.64583 13.2578 3.1875 12.8047C2.73438 12.3464 2.34375 11.8385 2.01563 11.2812C1.69271 10.724 1.4401 10.1276 1.25781 9.49219C1.08073 8.85156 0.992188 8.1875 0.992188 7.5C0.992188 6.8125 1.08073 6.15104 1.25781 5.51562C1.4401 4.875 1.69271 4.27604 2.01563 3.71875C2.34375 3.16146 2.73438 2.65625 3.1875 2.20312C3.64583 1.74479 4.15365 1.35417 4.71094 1.03125C5.26823 0.703125 5.86458 0.450521 6.5 0.273437C7.14062 0.0911458 7.80469 0 8.49219 0ZM8.49219 10C8.6276 10 8.74479 10.0495 8.84375 10.1484C8.94271 10.2474 8.99219 10.3646 8.99219 10.5C8.99219 10.6354 8.94271 10.7526 8.84375 10.8516C8.74479 10.9505 8.6276 11 8.49219 11C8.35677 11 8.23958 10.9505 8.14063 10.8516C8.04167 10.7526 7.99219 10.6354 7.99219 10.5C7.99219 10.3646 8.04167 10.2474 8.14063 10.1484C8.23958 10.0495 8.35677 10 8.49219 10ZM8.49219 1C7.89323 1 7.3151 1.07812 6.75781 1.23437C6.20573 1.38542 5.6875 1.60417 5.20312 1.89062C4.72396 2.17187 4.28646 2.51042 3.89063 2.90625C3.5 3.29688 3.16146 3.73438 2.875 4.21875C2.59375 4.69792 2.375 5.21615 2.21875 5.77344C2.06771 6.32552 1.99219 6.90104 1.99219 7.5C1.99219 8.09896 2.06771 8.67708 2.21875 9.23438C2.375 9.78646 2.59375 10.3047 2.875 10.7891C3.16146 11.2682 3.5 11.7057 3.89063 12.1016C4.28646 12.4922 4.72396 12.8307 5.20313 13.1172C5.6875 13.3984 6.20573 13.6172 6.75781 13.7734C7.3151 13.9245 7.89323 14 8.49219 14C9.09115 14 9.66667 13.9245 10.2188 13.7734C10.776 13.6172 11.2943 13.3984 11.7734 13.1172C12.2578 12.8307 12.6953 12.4922 13.0859 12.1016C13.4818 11.7057 13.8203 11.2682 14.1016 10.7891C14.388 10.3047 14.6068 9.78646 14.7578 9.23437C14.9141 8.67708 14.9922 8.09896 14.9922 7.5C14.9922 6.90104 14.9141 6.32552 14.7578 5.77344C14.6068 5.21615 14.388 4.69792 14.1016 4.21875C13.8203 3.73437 13.4818 3.29687 13.0859 2.90625C12.6953 2.51042 12.2578 2.17187 11.7734 1.89062C11.2943 1.60417 10.776 1.38542 10.2188 1.23437C9.66667 1.07812 9.09115 1 8.49219 1ZM8.99219 9H7.99219V4H8.99219L8.99219 9Z" fill="#FFA800" fill-opacity="0.8"/></svg></svg><b>Type something...</b><br /> Type detail</p>'
            },
            "successbox": {
              title: 'Success',
              position: {
                after: 'text'
              },
              icon: '<svg class="fal fa-check-circle"></svg>',
              template: '<p class="kv-editor-infobox success"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path d="M8.49219 0C9.17969 0 9.84115 0.0911458 10.4766 0.273437C11.1172 0.450521 11.7161 0.703125 12.2734 1.03125C12.8307 1.35417 13.3359 1.74479 13.7891 2.20312C14.2474 2.65625 14.638 3.16146 14.9609 3.71875C15.2891 4.27604 15.5417 4.875 15.7188 5.51562C15.901 6.15104 15.9922 6.8125 15.9922 7.5C15.9922 8.1875 15.901 8.85156 15.7188 9.49219C15.5417 10.1276 15.2891 10.724 14.9609 11.2812C14.638 11.8385 14.2474 12.3464 13.7891 12.8047C13.3359 13.2578 12.8307 13.6484 12.2734 13.9766C11.7161 14.2995 11.1172 14.5521 10.4766 14.7344C9.84115 14.9115 9.17969 15 8.49219 15C7.80469 15 7.14063 14.9115 6.5 14.7344C5.86458 14.5521 5.26823 14.2995 4.71094 13.9766C4.15365 13.6484 3.64583 13.2578 3.1875 12.8047C2.73438 12.3464 2.34375 11.8385 2.01563 11.2812C1.69271 10.724 1.4401 10.1276 1.25781 9.49219C1.08073 8.85156 0.992188 8.1875 0.992188 7.5C0.992188 6.8125 1.08073 6.15104 1.25781 5.51562C1.4401 4.875 1.69271 4.27604 2.01563 3.71875C2.34375 3.16146 2.73438 2.65625 3.1875 2.20312C3.64583 1.74479 4.15365 1.35417 4.71094 1.03125C5.26823 0.703125 5.86458 0.450521 6.5 0.273437C7.14062 0.0911458 7.80469 0 8.49219 0ZM8.49219 1C7.89323 1 7.3151 1.07812 6.75781 1.23437C6.20573 1.38542 5.6875 1.60417 5.20312 1.89062C4.72396 2.17187 4.28646 2.51042 3.89063 2.90625C3.5 3.29688 3.16146 3.73438 2.875 4.21875C2.59375 4.69792 2.375 5.21615 2.21875 5.77344C2.06771 6.32552 1.99219 6.90104 1.99219 7.5C1.99219 8.09896 2.06771 8.67708 2.21875 9.23438C2.375 9.78646 2.59375 10.3047 2.875 10.7891C3.16146 11.2682 3.5 11.7057 3.89063 12.1016C4.28646 12.4922 4.72396 12.8307 5.20313 13.1172C5.6875 13.3984 6.20573 13.6172 6.75781 13.7734C7.3151 13.9245 7.89323 14 8.49219 14C9.09115 14 9.66667 13.9245 10.2188 13.7734C10.776 13.6172 11.2943 13.3984 11.7734 13.1172C12.2578 12.8307 12.6953 12.4922 13.0859 12.1016C13.4818 11.7057 13.8203 11.2682 14.1016 10.7891C14.388 10.3047 14.6068 9.78646 14.7578 9.23437C14.9141 8.67708 14.9922 8.09896 14.9922 7.5C14.9922 6.90104 14.9141 6.32552 14.7578 5.77344C14.6068 5.21615 14.388 4.69792 14.1016 4.21875C13.8203 3.73437 13.4818 3.29687 13.0859 2.90625C12.6953 2.51042 12.2578 2.17187 11.7734 1.89062C11.2943 1.60417 10.776 1.38542 10.2188 1.23437C9.66667 1.07812 9.09115 1 8.49219 1ZM12.8438 5.85156L8.10938 10.625L5.14063 7.65625L5.84375 6.94531L8.10938 9.21094L12.1406 5.14844L12.8438 5.85156Z" fill="#1BC5BD" fill-opacity="0.8"/></svg><b>Type something...</b><br /> Type detail</p>'
            },
            "infobox": {
              title: 'Info',
              position: {
                after: 'text'
              },
              icon: '<svg class="fal fa-info-circle"></svg>',
              template: '<p class="kv-editor-infobox info"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.49976 0C3.36439 0 -0.000244141 3.36463 -0.000244141 7.5C-0.000244141 11.6354 3.36439 15 7.49976 15C11.6351 15 14.9998 11.6354 14.9998 7.5C14.9998 3.36463 11.6351 0 7.49976 0ZM7.49976 1.15385C11.0109 1.15385 13.8459 3.98888 13.8459 7.5C13.8459 11.0111 11.0109 13.8462 7.49976 13.8462C3.98864 13.8462 1.1536 11.0111 1.1536 7.5C1.1536 3.98888 3.98864 1.15385 7.49976 1.15385ZM6.92283 4.03846V5.19231H8.07668V4.03846H6.92283ZM6.92283 6.34615V10.9615H8.07668V6.34615H6.92283Z" fill="#465669"/></svg><b>Type something...</b><br /> Type detail</p>'
            },
            "panel": {
              title: 'Panel',
              position: {
                after: 'text'
              },
              icon: '<svg class="far fa-window-maximize"></svg>',
              template: '<table data-rx-type="table" data-rx-first-level="true" class="kv-editor-table rounded-table"><thead><tr data-rx-type="row"><th data-rx-type="cell" class="rx-block-focus"></th></tr></thead><tbody><tr data-rx-type="row"><td data-rx-type="cell" class=""></td></tr></tbody></table>'
            }
          }
        },
        image: {
          upload: function () {
            var _upload2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_upload, data) {
              var up_id, up_app, up_model, block, blob, formData, response, files;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (!(_this.uploadRedactor.id && _this.uploadRedactor.app && _this.uploadRedactor.model)) {
                      _context.next = 29;
                      break;
                    }
                    up_id = _this.uploadRedactor.id;
                    up_app = _this.uploadRedactor.app;
                    up_model = _this.uploadRedactor.model; // upload._showProgress();
                    _context.prev = 4;
                    block = _upload.app.block.get();
                    _context.next = 8;
                    return imageCropModalService({
                      image: URL.createObjectURL(data.files[0])
                    });
                  case 8:
                    blob = _context.sent;
                    formData = new FormData();
                    formData.append("file", blob, data.files[0].name);
                    _context.prev = 11;
                    _context.next = 14;
                    return new KivaProxy({
                      endpoint: up_app + "/" + up_model
                    }).submit("post", "".concat(up_app, "/").concat(up_model, "/").concat(up_id, "/attachment"), formData);
                  case 14:
                    response = _context.sent;
                    files = {
                      file: {
                        url: "".concat(_this.$kvApiBridgeUrl, "/data/").concat(up_app, "/").concat(up_model, "/").concat(up_id, "/attachment/").concat(response.file_id),
                        id: response.file_id
                      }
                    };
                    block.$block.focus();
                    _upload.complete(files, data.e);
                    _context.next = 24;
                    break;
                  case 20:
                    _context.prev = 20;
                    _context.t0 = _context["catch"](11);
                    _this.$message.error(_context.t0.description);
                    _upload.complete(null, data.e);
                  case 24:
                    _context.next = 29;
                    break;
                  case 26:
                    _context.prev = 26;
                    _context.t1 = _context["catch"](4);
                    _upload.complete(null, data.e);
                  case 29:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[4, 26], [11, 20]]);
            }));
            function upload(_x, _x2) {
              return _upload2.apply(this, arguments);
            }
            return upload;
          }(),
          multiple: false
        },
        plugins: ["alignment", 'blockcode', "table", "imageposition", "clips", "selector", "inlineformat", "removeformat", "underline", "myplugin", "extendedcodeblock", "paneloptions"],
        format: ["p", "h1", "h2", "h3", "h4", "ul", "ol"],
        link: {
          target: "_blank"
        },
        placeholder: "Type something to create an awesome content...",
        inlineformat: {
          items: ["u", "sup", "sub", "mark", "kbd", "codex", "bluespan", "greenspan", "yellowspan", "redspan", "grayspan", "bluebold", "greenbold", "yellowbold", "redbold"],
          itemsObj: {
            bluespan: {
              title: "<span style='color: #fff; background: #2887eb; padding: 2px 8px; border-radius: 3px;'>Bluespan</span> ",
              params: {
                tag: "span",
                attr: {
                  "class": "bluespan"
                }
              }
            },
            greenspan: {
              title: "<span style='color: #fff; background: #67C23A; padding: 2px 8px; border-radius: 3px;'>Greenspan</span> ",
              params: {
                tag: "span",
                attr: {
                  class: "bluespan"
                }
              }
            },
            yellowspan: {
              title: "<span style='color: #fff; background: #E6A23C; padding: 2px 8px; border-radius: 3px;'>Yellowpan</span> ",
              params: {
                tag: "span",
                attr: {
                  class: "bluespan"
                }
              }
            },
            redspan: {
              title: "<span style='color: #fff; background: #f64e60; padding: 2px 8px; border-radius: 3px;'>Redspan</span>",
              params: {
                tag: "span",
                attr: {
                  class: "redspan"
                }
              }
            },
            grayspan: {
              title: "<span style='color: #465669; background: #eaeef7; padding: 2px 8px; border-radius: 3px;'>Graypan</span> ",
              params: {
                tag: "span",
                attr: {
                  class: "grayspan"
                }
              }
            },
            bluebold: {
              title: "<b style='color: #2887eb;'>Bluebold</b> ",
              params: {
                tag: "b",
                attr: {
                  class: "bluebold",
                  "data-type": "my-mark"
                }
              }
            },
            greenbold: {
              title: "<b style='color: #67C23A;'>Greenbold</b> ",
              params: {
                tag: "b",
                attr: {
                  class: "greenbold",
                  "data-type": "my-mark"
                }
              }
            },
            yellowbold: {
              title: "<b style='color: #E6A23C;'>Yellowbold</b> ",
              params: {
                tag: "b",
                attr: {
                  class: "yellowbold",
                  "data-type": "my-mark"
                }
              }
            },
            redbold: {
              title: "<b style='color: #f64e60;'>Redbold</b> ",
              params: {
                tag: "b",
                attr: {
                  class: "redbold",
                  "data-type": "my-mark"
                }
              }
            },
            codex: {
              title: "<b style='color: #000;'>Code</b>",
              params: {
                tag: "span",
                attr: {
                  class: "kv-code-block language-csharp language-javascript language-sql language-auto",
                  "data-type": "code"
                }
              }
            }
          }
        }
      },
      confingRedactorXTask: {
        source: false,
        reorder: true,
        control: true,
        context: true,
        minHeight: '200px',
        // toolbar: true,
        editor: {
          focus: true,
          notranslate: true
        },
        classes: {
          'p': 'kv-editor-p',
          'heading ': 'kv-heading',
          'image': 'kv-editor-img',
          'table': 'kv-editor-table'
        },
        clips: {
          items: {
            "kiva-panel-ul": {
              title: 'Kiva Panel ul.',
              html: '<p  class="kiva-panel-title">Title</p><ul  class="kiva-panel-ul"><li>Item</li></ul>'
            },
            "kiva-title-panel": {
              title: 'Kiva Panel',
              html: '<p  class="kiva-panel-title">Title</p><p  class="kiva-panel-content">Content</p>'
            },
            "kiva-pre": {
              title: 'Kiva Code',
              html: '<p  class="kiva-panel-title">Title</p><pre  class="kiva-panel-content"></pre>'
            },
            "kiva-title": {
              title: 'Kiva Title',
              html: '<p  class="kiva-panel-title">Title</p> '
            },
            "kiva-panel": {
              title: 'Kiva Panel',
              html: '<p  class="kiva-panel-content">Content</p>'
            },
            "kiva-article": {
              title: 'Kiva Panel',
              html: '<p  class="kiva-panel-title">Title</p><table  class="kiva-panel-table"><tr><td>Content</td></tr></table>'
            }
          }
        },
        addbar: {
          add: {
            "warningbox": {
              title: 'Warning',
              position: {
                after: 'text'
              },
              icon: '<svg class="fal fa-exclamation-circle"></svg>',
              template: '<p class="kv-editor-infobox warning"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path d="M8.49219 0C9.17969 0 9.84115 0.0911458 10.4766 0.273437C11.1172 0.450521 11.7161 0.703125 12.2734 1.03125C12.8307 1.35417 13.3359 1.74479 13.7891 2.20312C14.2474 2.65625 14.638 3.16146 14.9609 3.71875C15.2891 4.27604 15.5417 4.875 15.7188 5.51562C15.901 6.15104 15.9922 6.8125 15.9922 7.5C15.9922 8.1875 15.901 8.85156 15.7188 9.49219C15.5417 10.1276 15.2891 10.724 14.9609 11.2812C14.638 11.8385 14.2474 12.3464 13.7891 12.8047C13.3359 13.2578 12.8307 13.6484 12.2734 13.9766C11.7161 14.2995 11.1172 14.5521 10.4766 14.7344C9.84115 14.9115 9.17969 15 8.49219 15C7.80469 15 7.14063 14.9115 6.5 14.7344C5.86458 14.5521 5.26823 14.2995 4.71094 13.9766C4.15365 13.6484 3.64583 13.2578 3.1875 12.8047C2.73438 12.3464 2.34375 11.8385 2.01563 11.2812C1.69271 10.724 1.4401 10.1276 1.25781 9.49219C1.08073 8.85156 0.992188 8.1875 0.992188 7.5C0.992188 6.8125 1.08073 6.15104 1.25781 5.51562C1.4401 4.875 1.69271 4.27604 2.01563 3.71875C2.34375 3.16146 2.73438 2.65625 3.1875 2.20312C3.64583 1.74479 4.15365 1.35417 4.71094 1.03125C5.26823 0.703125 5.86458 0.450521 6.5 0.273437C7.14062 0.0911458 7.80469 0 8.49219 0ZM8.49219 10C8.6276 10 8.74479 10.0495 8.84375 10.1484C8.94271 10.2474 8.99219 10.3646 8.99219 10.5C8.99219 10.6354 8.94271 10.7526 8.84375 10.8516C8.74479 10.9505 8.6276 11 8.49219 11C8.35677 11 8.23958 10.9505 8.14063 10.8516C8.04167 10.7526 7.99219 10.6354 7.99219 10.5C7.99219 10.3646 8.04167 10.2474 8.14063 10.1484C8.23958 10.0495 8.35677 10 8.49219 10ZM8.49219 1C7.89323 1 7.3151 1.07812 6.75781 1.23437C6.20573 1.38542 5.6875 1.60417 5.20312 1.89062C4.72396 2.17187 4.28646 2.51042 3.89063 2.90625C3.5 3.29688 3.16146 3.73438 2.875 4.21875C2.59375 4.69792 2.375 5.21615 2.21875 5.77344C2.06771 6.32552 1.99219 6.90104 1.99219 7.5C1.99219 8.09896 2.06771 8.67708 2.21875 9.23438C2.375 9.78646 2.59375 10.3047 2.875 10.7891C3.16146 11.2682 3.5 11.7057 3.89063 12.1016C4.28646 12.4922 4.72396 12.8307 5.20313 13.1172C5.6875 13.3984 6.20573 13.6172 6.75781 13.7734C7.3151 13.9245 7.89323 14 8.49219 14C9.09115 14 9.66667 13.9245 10.2188 13.7734C10.776 13.6172 11.2943 13.3984 11.7734 13.1172C12.2578 12.8307 12.6953 12.4922 13.0859 12.1016C13.4818 11.7057 13.8203 11.2682 14.1016 10.7891C14.388 10.3047 14.6068 9.78646 14.7578 9.23437C14.9141 8.67708 14.9922 8.09896 14.9922 7.5C14.9922 6.90104 14.9141 6.32552 14.7578 5.77344C14.6068 5.21615 14.388 4.69792 14.1016 4.21875C13.8203 3.73437 13.4818 3.29687 13.0859 2.90625C12.6953 2.51042 12.2578 2.17187 11.7734 1.89062C11.2943 1.60417 10.776 1.38542 10.2188 1.23437C9.66667 1.07812 9.09115 1 8.49219 1ZM8.99219 9H7.99219V4H8.99219L8.99219 9Z" fill="#FFA800" fill-opacity="0.8"/></svg></svg><b>Type something...</b><br /> Type detail</p>'
            },
            "successbox": {
              title: 'Success',
              position: {
                after: 'text'
              },
              icon: '<svg class="fal fa-check-circle"></svg>',
              template: '<p class="kv-editor-infobox success"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path d="M8.49219 0C9.17969 0 9.84115 0.0911458 10.4766 0.273437C11.1172 0.450521 11.7161 0.703125 12.2734 1.03125C12.8307 1.35417 13.3359 1.74479 13.7891 2.20312C14.2474 2.65625 14.638 3.16146 14.9609 3.71875C15.2891 4.27604 15.5417 4.875 15.7188 5.51562C15.901 6.15104 15.9922 6.8125 15.9922 7.5C15.9922 8.1875 15.901 8.85156 15.7188 9.49219C15.5417 10.1276 15.2891 10.724 14.9609 11.2812C14.638 11.8385 14.2474 12.3464 13.7891 12.8047C13.3359 13.2578 12.8307 13.6484 12.2734 13.9766C11.7161 14.2995 11.1172 14.5521 10.4766 14.7344C9.84115 14.9115 9.17969 15 8.49219 15C7.80469 15 7.14063 14.9115 6.5 14.7344C5.86458 14.5521 5.26823 14.2995 4.71094 13.9766C4.15365 13.6484 3.64583 13.2578 3.1875 12.8047C2.73438 12.3464 2.34375 11.8385 2.01563 11.2812C1.69271 10.724 1.4401 10.1276 1.25781 9.49219C1.08073 8.85156 0.992188 8.1875 0.992188 7.5C0.992188 6.8125 1.08073 6.15104 1.25781 5.51562C1.4401 4.875 1.69271 4.27604 2.01563 3.71875C2.34375 3.16146 2.73438 2.65625 3.1875 2.20312C3.64583 1.74479 4.15365 1.35417 4.71094 1.03125C5.26823 0.703125 5.86458 0.450521 6.5 0.273437C7.14062 0.0911458 7.80469 0 8.49219 0ZM8.49219 1C7.89323 1 7.3151 1.07812 6.75781 1.23437C6.20573 1.38542 5.6875 1.60417 5.20312 1.89062C4.72396 2.17187 4.28646 2.51042 3.89063 2.90625C3.5 3.29688 3.16146 3.73438 2.875 4.21875C2.59375 4.69792 2.375 5.21615 2.21875 5.77344C2.06771 6.32552 1.99219 6.90104 1.99219 7.5C1.99219 8.09896 2.06771 8.67708 2.21875 9.23438C2.375 9.78646 2.59375 10.3047 2.875 10.7891C3.16146 11.2682 3.5 11.7057 3.89063 12.1016C4.28646 12.4922 4.72396 12.8307 5.20313 13.1172C5.6875 13.3984 6.20573 13.6172 6.75781 13.7734C7.3151 13.9245 7.89323 14 8.49219 14C9.09115 14 9.66667 13.9245 10.2188 13.7734C10.776 13.6172 11.2943 13.3984 11.7734 13.1172C12.2578 12.8307 12.6953 12.4922 13.0859 12.1016C13.4818 11.7057 13.8203 11.2682 14.1016 10.7891C14.388 10.3047 14.6068 9.78646 14.7578 9.23437C14.9141 8.67708 14.9922 8.09896 14.9922 7.5C14.9922 6.90104 14.9141 6.32552 14.7578 5.77344C14.6068 5.21615 14.388 4.69792 14.1016 4.21875C13.8203 3.73437 13.4818 3.29687 13.0859 2.90625C12.6953 2.51042 12.2578 2.17187 11.7734 1.89062C11.2943 1.60417 10.776 1.38542 10.2188 1.23437C9.66667 1.07812 9.09115 1 8.49219 1ZM12.8438 5.85156L8.10938 10.625L5.14063 7.65625L5.84375 6.94531L8.10938 9.21094L12.1406 5.14844L12.8438 5.85156Z" fill="#1BC5BD" fill-opacity="0.8"/></svg><b>Type something...</b><br /> Type detail</p>'
            },
            "infobox": {
              title: 'Info',
              position: {
                after: 'text'
              },
              icon: '<svg class="fal fa-info-circle"></svg>',
              template: '<p class="kv-editor-infobox info"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.49976 0C3.36439 0 -0.000244141 3.36463 -0.000244141 7.5C-0.000244141 11.6354 3.36439 15 7.49976 15C11.6351 15 14.9998 11.6354 14.9998 7.5C14.9998 3.36463 11.6351 0 7.49976 0ZM7.49976 1.15385C11.0109 1.15385 13.8459 3.98888 13.8459 7.5C13.8459 11.0111 11.0109 13.8462 7.49976 13.8462C3.98864 13.8462 1.1536 11.0111 1.1536 7.5C1.1536 3.98888 3.98864 1.15385 7.49976 1.15385ZM6.92283 4.03846V5.19231H8.07668V4.03846H6.92283ZM6.92283 6.34615V10.9615H8.07668V6.34615H6.92283Z" fill="#465669"/></svg><b>Type something...</b><br /> Type detail</p>'
            },
            "panel": {
              title: 'Panel',
              position: {
                after: 'text'
              },
              icon: '<svg class="far fa-window-maximize"></svg>',
              template: '<table data-rx-type="table" data-rx-first-level="true" class="kv-editor-table rounded-table"><thead><tr data-rx-type="row"><th data-rx-type="cell" class="rx-block-focus"></th></tr></thead><tbody><tr data-rx-type="row"><td data-rx-type="cell" class=""></td></tr></tbody></table>'
            }
          }
        },
        image: {
          upload: function () {
            var _upload4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_upload3, data) {
              var up_id, up_app, up_model, block, blob, formData, response, files;
              return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!(_this.uploadRedactor.id && _this.uploadRedactor.app && _this.uploadRedactor.model)) {
                      _context2.next = 29;
                      break;
                    }
                    up_id = _this.uploadRedactor.id;
                    up_app = _this.uploadRedactor.app;
                    up_model = _this.uploadRedactor.model; // upload._showProgress();
                    _context2.prev = 4;
                    block = _upload3.app.block.get();
                    _context2.next = 8;
                    return imageCropModalService({
                      image: URL.createObjectURL(data.files[0])
                    });
                  case 8:
                    blob = _context2.sent;
                    formData = new FormData();
                    formData.append("file", blob, data.files[0].name);
                    _context2.prev = 11;
                    _context2.next = 14;
                    return new KivaProxy({
                      endpoint: up_app + "/" + up_model
                    }).submit("post", "".concat(up_app, "/").concat(up_model, "/").concat(up_id, "/attachment"), formData);
                  case 14:
                    response = _context2.sent;
                    files = {
                      file: {
                        url: "".concat(_this.$kvApiBridgeUrl, "/data/").concat(up_app, "/").concat(up_model, "/").concat(up_id, "/attachment/").concat(response.file_id),
                        id: response.file_id
                      }
                    };
                    block.$block.focus();
                    _upload3.complete(files, data.e);
                    _context2.next = 24;
                    break;
                  case 20:
                    _context2.prev = 20;
                    _context2.t0 = _context2["catch"](11);
                    _this.$message.error(_context2.t0.description);
                    _upload3.complete(null, data.e);
                  case 24:
                    _context2.next = 29;
                    break;
                  case 26:
                    _context2.prev = 26;
                    _context2.t1 = _context2["catch"](4);
                    _upload3.complete(null, data.e);
                  case 29:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2, null, [[4, 26], [11, 20]]);
            }));
            function upload(_x3, _x4) {
              return _upload4.apply(this, arguments);
            }
            return upload;
          }(),
          multiple: false
        },
        plugins: ["alignment", 'blockcode', "table", "imageposition", "clips", "selector", "inlineformat", "removeformat", "underline", "myplugin", "extendedcodeblock", "paneloptions"],
        format: ["p", "h1", "h2", "h3", "h4", "ul", "ol"],
        link: {
          target: "_blank"
        },
        placeholder: "Type something to create an awesome content...",
        inlineformat: {
          items: ["u", "sup", "sub", "mark", "kbd", "codex", "bluespan", "greenspan", "yellowspan", "redspan", "grayspan", "bluebold", "greenbold", "yellowbold", "redbold"],
          itemsObj: {
            bluespan: {
              title: "<span style='color: #fff; background: #2887eb; padding: 2px 8px; border-radius: 3px;'>Bluespan</span> ",
              params: {
                tag: "span",
                attr: {
                  "class": "bluespan"
                }
              }
            },
            greenspan: {
              title: "<span style='color: #fff; background: #67C23A; padding: 2px 8px; border-radius: 3px;'>Greenspan</span> ",
              params: {
                tag: "span",
                attr: {
                  class: "bluespan"
                }
              }
            },
            yellowspan: {
              title: "<span style='color: #fff; background: #E6A23C; padding: 2px 8px; border-radius: 3px;'>Yellowpan</span> ",
              params: {
                tag: "span",
                attr: {
                  class: "bluespan"
                }
              }
            },
            redspan: {
              title: "<span style='color: #fff; background: #f64e60; padding: 2px 8px; border-radius: 3px;'>Redspan</span>",
              params: {
                tag: "span",
                attr: {
                  class: "redspan"
                }
              }
            },
            grayspan: {
              title: "<span style='color: #465669; background: #eaeef7; padding: 2px 8px; border-radius: 3px;'>Graypan</span> ",
              params: {
                tag: "span",
                attr: {
                  class: "grayspan"
                }
              }
            },
            bluebold: {
              title: "<b style='color: #2887eb;'>Bluebold</b> ",
              params: {
                tag: "b",
                attr: {
                  class: "bluebold",
                  "data-type": "my-mark"
                }
              }
            },
            greenbold: {
              title: "<b style='color: #67C23A;'>Greenbold</b> ",
              params: {
                tag: "b",
                attr: {
                  class: "greenbold",
                  "data-type": "my-mark"
                }
              }
            },
            yellowbold: {
              title: "<b style='color: #E6A23C;'>Yellowbold</b> ",
              params: {
                tag: "b",
                attr: {
                  class: "yellowbold",
                  "data-type": "my-mark"
                }
              }
            },
            redbold: {
              title: "<b style='color: #f64e60;'>Redbold</b> ",
              params: {
                tag: "b",
                attr: {
                  class: "redbold",
                  "data-type": "my-mark"
                }
              }
            },
            codex: {
              title: "<b style='color: #000;'>Code</b>",
              params: {
                tag: "span",
                attr: {
                  class: "kv-code-block language-csharp language-javascript language-sql language-auto",
                  "data-type": "code"
                }
              }
            }
          }
        }
      }
    };
  },
  methods: {
    getDocumentPath: function getDocumentPath(_ref) {
      var recordId = _ref.recordId,
        id = _ref.id;
      return "".concat(this.$kvDocumentPath, "/").concat(recordId, "/document/").concat(id);
    },
    downloadDocumentPath: function downloadDocumentPath(_ref2) {
      var recordId = _ref2.recordId,
        id = _ref2.id;
      var blank = '?blank=1';
      var r = "".concat(this.$kvDocumentPath, "/").concat(recordId, "/document/").concat(id).concat(blank);
      window.open(r);
    },
    findDocumentPath: function findDocumentPath(_ref3) {
      var recordId = _ref3.recordId,
        id = _ref3.id;
      return "".concat(this.$kvDocumentPath, "/").concat(recordId, "/document/").concat(id);
    },
    getAccountImagePath: function getAccountImagePath(_ref4, isThumb) {
      var recordId = _ref4.recordId,
        id = _ref4.id;
      var thumb = isThumb ? '?thumb=1' : '';
      return "".concat(this.$kvBaseUrl, "/apibridge/data/crm/account/").concat(recordId, "/photo/").concat(id).concat(thumb);
    },
    getProjectImagePath: function getProjectImagePath(_ref5, isThumb) {
      var recordId = _ref5.recordId,
        id = _ref5.id;
      var thumb = isThumb ? '?thumb=1' : '';
      return "".concat(this.$kvBaseUrl, "/apibridge/data/act/project/").concat(recordId, "/photo/").concat(id).concat(thumb);
    },
    getContactImagePath: function getContactImagePath(_ref6, isThumb) {
      var recordId = _ref6.recordId,
        id = _ref6.id;
      var thumb = isThumb ? '?thumb=1' : '';
      return "".concat(this.$kvBaseUrl, "/apibridge/data/crm/contact/").concat(recordId, "/photo/").concat(id).concat(thumb);
    },
    getImage: function getImage(_ref7, isThumb) {
      var recordId = _ref7.recordId,
        id = _ref7.id,
        app = _ref7.app,
        model = _ref7.model,
        field = _ref7.field;
      var thumb = isThumb ? '?thumb=1' : '';
      return "".concat(this.$kvBaseUrl, "/apibridge/data/").concat(app, "/").concat(model, "/").concat(recordId, "/").concat(field, "/").concat(id).concat(thumb);
    },
    hasProduct: function hasProduct(product) {
      var found = this.$licenses.find(function (k) {
        return product.includes(k.packageAppId);
      });
      if (found && found["packageAppId"]) {
        return true;
      }
      return false;
    },
    hasVersion: function hasVersion(_ref8) {
      var module = _ref8.module,
        process = _ref8.process;
      return true;
    },
    hasVProfile: function hasVProfile(_ref9) {
      var module = _ref9.module,
        process = _ref9.process;
      return true;
    }
  },
  computed: {
    $kvBaseUrl: function $kvBaseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
    $kvApiBridgeUrl: function $kvApiBridgeUrl() {
      return process.env.VUE_APP_API_BRIDGE;
    },
    $kvDocumentPath: function $kvDocumentPath() {
      return process.env.VUE_APP_DOCUMENT_PATH;
    },
    $kvAttachmentViewPath: function $kvAttachmentViewPath() {
      return process.env.VUE_APP_ATTACHMENT_VIEW_PATH;
    },
    $isApp: function $isApp() {
      return process.env.VUE_APP_APP_ID;
    },
    $isRulesup: function $isRulesup() {
      return this.$isApp === 'rulesup';
    },
    $isKiva: function $isKiva() {
      return this.$isApp === 'kiva';
    },
    $licenses: function $licenses() {
      return this.$store.state.users.CURRENT_USER.licenses;
    },
    $me: function $me() {
      return this.$store.state.users.CURRENT_USER;
    },
    $locale: function $locale() {
      var lg = this.$store.state.users.CURRENT_USER && this.$store.state.users.CURRENT_USER.language ? this.$store.state.users.CURRENT_USER.language : '';
      return lg ? lg.substring(0, 2) : 'en';
    }
  }
});